import {
  Backdrop,
  Button,
  Container,
  Select,
  InputLabel,
  Fade,
  FormControl,
  Grid,
  // Modal,
  Paper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import "../../App.css";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  // Table,
  Row,
  Col,
  UncontrolledAlert,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";

import Modal from "react-awesome-modal";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { Component } from "react";
import Constants from "../Variables/Constants";
import init from "../../helpers/WindowToken";
import { lastPageRecordCount } from "./Components/PaginationTool";
import "../../App.css";

export default class Banners extends Component {
  state = {
    allBanners: [],
    search: "",
    title: "",
    sequence: "",
    created_by: "",
    name: "",

    limit: 10,
    page: 1,
    nextPage: null,
    prevPage: null,
    totalDocs: 0,
    totalPages: 1,

    rowId: "",
    visible: false,
    loading: false,
    notifyDelete: false,
    delMsg: "",
    delLoading: false,
    deleteMessage: "",
    requestError: "",
  };

  componentDidMount() {
    this.getbanner();
  }

  handleRequestError = (error, fallbackState = {}) => {
    this.setState({
      ...fallbackState,
      delLoading: false,
      requestError:
        error?.response?.data?.message || error?.message || "Failed to load banners",
    });
  };

  getbanner = () => {
    //   if ( init() === "success" ){
    axios
      .get(
        Constants.getUrls.getallBanners +
          `?limit=${this.state.limit}` +
          `&page=${this.state.page}`
      )

      .then((resp) => {
        console.log(resp);
        this.setState({
          allBanners: resp.data.data.docs,
          limit: resp.data.data.limit,
          nextPage: resp.data.data.nextPage,
          page: resp.data.data.page,
          prevPage: resp.data.data.prevPage,
          totalDocs: resp.data.data.totalDocs,
          totalPages: resp.data.data.totalPages,
          requestError: "",
        });
      })
      .catch((error) => {
        this.handleRequestError(error, {
          allBanners: [],
          nextPage: null,
          prevPage: null,
          totalDocs: 0,
          totalPages: 1,
        });
      });
    //   }
  };

  handleSelect = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (init() === "success") {
          axios
            .get(
              Constants.getUrls.getallBanners +
                `?limit=${this.state.limit}` +
                `&page=${1}`
            )
            .then((resp) => {
              console.log(resp);
              this.setState({
                allBanners: resp.data.data.docs,
                limit: resp.data.data.limit,
                nextPage: resp.data.data.nextPage,
                page: resp.data.data.page,
                prevPage: resp.data.data.prevPage,
                totalDocs: resp.data.data.totalDocs,
                totalPages: resp.data.data.totalPages,
                requestError: "",
              });
            })
            .catch((error) => {
              this.handleRequestError(error);
            });
        }
      }
    );
  };

  handleNext = () => {
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.getallBanners +
            `?limit=${this.state.limit}` +
            `&page=${this.state.page + 1}`
        )

        .then((resp) => {
          console.log(this.state.allBanners, this.state.page);
          this.setState({
            allBanners: resp.data.data.docs,
            limit: resp.data.data.limit,
            nextPage: resp.data.data.nextPage,
            page: resp.data.data.page,
            prevPage: resp.data.data.prevPage,
            totalDocs: resp.data.data.totalDocs,
            totalPages: resp.data.data.totalPages,
            requestError: "",
          });
        })
        .catch((error) => {
          this.handleRequestError(error);
        });
    }
  };

  handlePrev = () => {
    if (this.state.page > 1) {
      if (init() === "success") {
        axios
          .get(
            Constants.getUrls.getallBanners +
              `?limit=${this.state.limit}` +
              `&page=${this.state.page - 1}`
          )

          .then((resp) => {
            console.log(resp);
            this.setState({
              allBanners: resp.data.data.docs,
              limit: resp.data.data.limit,
              nextPage: resp.data.data.nextPage,
              page: resp.data.data.page,
              prevPage: resp.data.data.prevPage,
              totalDocs: resp.data.data.totalDocs,
              totalPages: resp.data.data.totalPages,
              requestError: "",
            });
          })
          .catch((error) => {
            this.handleRequestError(error);
          });
      }
    }
  };

  handleChange = (event, value) => {
    this.setState(
      {
        page: value,
      },
      () => {
        this.getbanner();
      }
    );
  };
  // search ends

  // delete starts
  handleModal = (banner) => {
    this.setState({
      visible: true,
      rowId: banner?._id,
    });
  };

  handleDelete = () => {
    this.setState({
      delLoading: true,
    });
    let payload = {
      _id: this.state.rowId,
    };

    if (init() == "success") {
      // this.setState({ delLoading: true });
      axios
        .delete(
          `${Constants.deleteUrls.deletebanner}${this.state.rowId}?confirm=yes`
        )
        .then((res) => {
          console.log(res);
          this.setState({
            deletebanner: true,
            delLoading: false,
            delMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({ deletebanner: false, visible: false }, () => {
              this.getbanner();
            });
          }, 2000);
        })
        .catch((error) => {
          this.handleRequestError(error, { visible: false });
        });
    }
  };

  handleStatus = (contest, contestID) => {
    if (init() === "success") {
      let statusLoad = {
        status: contest,
      };
      // console.log(contest)
      axios
        .put(Constants.putUrls.bannerStatus + contestID, statusLoad)
        .then((resp) => {
          this.setState({
            status: true,
          });
          setTimeout(() => {
            this.setState({ status: false }, () => {
              this.getbanner();
            });
          }, 1000);
        })
        .catch((error) => {
          this.handleRequestError(error);
        });
    }
  };

  render() {
    return (
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(this.state.requestError)}
          autoHideDuration={4000}
          onClose={() => this.setState({ requestError: "" })}
          message={this.state.requestError}
        />
        <Grid container spcaing={2}>
          <Grid item sm={6}>
            <Typography variant="h4">Banners</Typography>
          </Grid>
          <Grid container justify="flex-end">
            {/* <FormControl >
                          <TextField
                              id="standard-basic"
                              label="Search Testimonial"
                              variant="standard"
                              size="small"
                              name="search"
                              onChange={this.handleChange}
                              />
                      </FormControl> */}

            <Link
              to="/admin/addbanner"
              style={{ textDecoration: "none", marginBottom: "1rem" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="medium"
                onClick={() => {
                  this.setState({ open: true });
                }}
              >
                Add Banner
              </Button>
            </Link>
          </Grid>
        </Grid>

        <Grid sm={12}>
          <Paper elevetion={1}>
            <TableContainer>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>S.No</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell align="center">Image</TableCell>
                    <TableCell align="center">Category</TableCell>
                    <TableCell align="center">Link</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.allBanners?.length > 0 ? (
                    this.state.allBanners.map((banner, index) => (
                      <TableRow>
                        <TableCell>
                          {" "}
                          {Number((this.state.page - 1) * this.state.limit) +
                            Number(index + 1)}{" "}
                        </TableCell>
                        <TableCell> {banner.title} </TableCell>
                        <TableCell align="center">
                          <img src={Constants.imgDomain + banner.image} style={{height: "50px"}} />
                          </TableCell>
                        <TableCell align="center">
                          {banner?.category_id?.title || "-"}
                        </TableCell>
                        <TableCell align="center">
                          {" "}
                          {banner.link}
                        </TableCell>
                        <TableCell align="center">
                          <Switch
                            color="primary"
                            variant="secondary"
                            name="chackedB"
                            checked={banner?.status === "inactive" ? false : true}
                            onChange={(e) =>
                              this.handleStatus(
                                banner?.status === "inactive"
                                  ? "active"
                                  : "inactive",
                                banner._id
                              )
                            }
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </TableCell>

                        <TableCell align="center">
                          <Link
                            to={{
                              pathname:
                                "/admin/updatebanner/" + banner._id,
                              state: { data: banner },
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              variant={"outlined"}
                              color="default"
                              style={{ marginRight: 4 }}
                              size={"small"}
                            >
                              Update
                            </Button>
                          </Link>
                          <Button
                            size={"small"}
                            variant={"outlined"}
                            color="secondary"
                            onClick={() => {
                              this.handleModal(banner);
                            }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell>NO DATA FOUND</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <TableRow
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <div>
                  <p>
                    {Number((this.state.page - 1) * this.state.limit) + 1} to{" "}
                    {lastPageRecordCount(
                      this.state.totalDocs,
                      this.state.page,
                      this.state.limit
                    )}{" "}
                    of {this.state.totalDocs} Entries
                  </p>
                </div>

                {/* Rows PerPage START */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <p>Rows Per Page</p>

                  <FormControl
                    className="selectMerchants"
                    style={{ marginRight: "20px", marginTop: "-12px" }}
                  >
                    <InputLabel htmlFor="age-native-simple"></InputLabel>
                    <Select
                      native
                      value={this.state.limit}
                      onChange={this.handleSelect}
                      inputProps={{
                        name: "limit",
                        id: "age-native-simple",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Select>
                  </FormControl>
                </div>

                {/* Rows PerPage END */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginLeft: "290px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="mx-5"
                    style={{ margin: "10px" }}
                    disabled={this.state.prevPage === null}
                    onClick={this.handlePrev}
                    // Hidden
                  >
                    Previous
                  </Button>{" "}
                  <Pagination
                    count={this.state.totalPages}
                    shape="rounded"
                    page={this.state.page}
                    onChange={this.handleChange}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-5"
                    disabled={this.state.nextPage === null}
                    style={{ margin: "10px" }}
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </div>
              </TableRow>
            </TableContainer>
          </Paper>
        </Grid>
        <Modal
          visible={this.state.visible}
          onClickAway={() => this.setState({ visible: false })}
          width="500px"
          height="80px"
          effect="fadeInUp"
        >
          <Row>
            <Col xs={12} xm={12} md={12}>
              <Card>
                <CardBody>
                  <div className="modal">
                    <h3
                      classname="changeColor"
                      style={{ color: "black", marginLeft: "13px" }}
                    >
                      Are you sure you want to delete ?
                      {this.state.deleteMessage}
                    </h3>

                    {this.state.deletebanner ? (
                      <Snackbar
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "bottom",
                        }}
                        open={true}
                        autoHideDuration={5000}
                        color={"s"}
                        message="deleted Successfully"
                      ></Snackbar>
                    ) : null}

                    <Row>
                      <Col xs={12} xm={12} md={4}>
                        <br />
                        <Button
                          className=""
                          color="secondary"
                          variant="contained"
                          style={{ margin: "10px" }}
                          onClick={() => {
                            this.handleDelete(this.state.rowId);
                          }}
                        >
                          {this.state.deletebanner
                            ? "Deleting banner"
                            : "Yes"}
                        </Button>
                        <Button
                          className=""
                          variant="contained"
                          color="primary"
                          style={{ margin: "10px", marginLeft: "4px" }}
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          No
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Modal>
      </Container>
    );
  }
}
